// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".changeBg[data-v-39100310]{background-color:var(--portalCardBtn)}.changeBg[data-v-39100310]:hover{background-color:var(--portalCardBtnHover)}", ""]);
// Exports
module.exports = exports;
